<canvas
  baseChart
  *ngIf="safeChartData"
  [id]="chartId"
  [data]="safeChartData"
  [options]="chartOptions"
  [type]="chartType">
</canvas>
